import React from 'react'

function Image({ component}){
    return (
        <div className={`cursor-default`}>
            {!component.value ?
                <img src="/images/form-placeholder-image.svg" alt={component.alt || 'placeholder'} className='object-cover' style={component.styles} />
                : <img className="form-image object-fill max-h-[500px] max-w-[500px]" src={component?.image_url} style={component?.styles} alt={component?.alt} />}
        </div>
    )
}

export default Image